module.exports = __webpack_public_path__ + "img/login-header.f9b88875.svg";